<template>
  <div class="send">
    <template>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" forceRender>
          <span slot="tab">
            <a-icon type="smile" theme="twoTone" />
            每日动态
          </span>
          <SendEveryday />
        </a-tab-pane>
        <!-- <a-tab-pane key="2" forceRender>
          <span slot="tab">
            <a-icon type="usb" theme="twoTone" />
            资源共享
          </span>
          <SendShare />
        </a-tab-pane> -->
        <a-tab-pane key="3" >
          <span slot="tab" @click="reload">
            <a-icon type="bug" theme="twoTone" />
            <!-- <a-icon type="android" /> -->
            架构领域
          </span>
          <SendTelegraph v-if="isRouterAlive" />
        </a-tab-pane>
      </a-tabs>
    </template>
  </div>
</template>


<script>
import sendtelegraph from "@/components/user/usercolumn/release/sendtelegraph";
import sendshare from "@/components/user/usercolumn/release/sendshare";
import sendeveryday from "@/components/user/usercolumn/release/sendeveryday";
export default {
  name: "send",
  data() {
    return {
      discussion: "+++++++++++",

      isRouterAlive: true,
    };
  },

  components: {
    SendTelegraph: sendtelegraph,
    SendShare: sendshare,
    SendEveryday: sendeveryday,
  },
  methods: {
    // changeTabs: (activeKey) => {
    //   setCurTabKey(activeKey);
    // },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
  },
};
</script>

<style lang="less" scoped>
.send {
  width: 100%;
  background-color: rgb(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/release/send.vue